/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const LeftIconWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    fill: ${Palette.PrimaryGray._400};
  }
`;

export const RightBtnWrap = styled.div`
  margin-left: auto;
  ${({ isVisible }) =>
    !isVisible &&
    css`
      visibility: hidden;
    `}
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;

  width: ${({ width }) => (width ? `${width}px` : '100%')};
  padding: 4px 0;
  height: 32px;
  ${({ isFocused, isHovered, disabled, isError }) => {
    if (disabled)
      return css`
        cursor: not-allowed;
        opacity: 0.5;
      `;
    if (isError)
      return css`
        ${LeftIconWrap} {
          svg {
            fill: ${Palette.Red._500};
          }
        }
      `;
    if (isHovered && !isFocused)
      return css`
        ${LeftIconWrap} {
          svg {
            fill: ${Palette.PrimaryGray._500};
          }
        }
      `;
    if (isFocused)
      return css`
        ${LeftIconWrap} {
          svg {
            fill: ${Palette.Primary._500};
          }
        }
      `;
  }}
`;

export const MyInput = styled.input`
  width: 100%;
  border: 0;
  outline: none;
  color: ${Palette.PrimaryGray._900};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  height: 20px;
  ::placeholder {
    opacity: 0.5;
  }
  :disabled {
    cursor: not-allowed;
    background: transparent;
  }
`;
